import { render, staticRenderFns } from "./SupplierEditTabCore.vue?vue&type=template&id=c5336838&"
import script from "./SupplierEditTabCore.vue?vue&type=script&lang=js&"
export * from "./SupplierEditTabCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports